import { BaseModel } from '../../../../../../../core/_base/crud';

export class DeNghiMuaHang extends BaseModel {

    static category_path = "PDNMH";
    static PRESENT_ACCOUNT_MH = "phap.nha";
    static DEFAULT_NUMBER_VALUE = "0,00";
    static DEFAULT_NUMBER_VALUE_NUMBER = "0.00";

    static optionsLoaiPhieu: any = [
        {
            id: 1,
            value: 'NHUCAUPHATSINH',
            name: 'Theo nhu cầu'
        },
        {
            id: 2,
            value: 'NHUCAUKEHOACH',
            name: 'Theo kế hoạch'
        }
    ];
    static optionsTinhTrang: any = [
        {
            id: 1,
            name: 'Đang soạn thảo',
            value: 'PDNMH_PHIEUMOI',
        },
        {
            id: 2,
            name: 'Chờ TP duyệt',
            value: 'PDNMH_CHODUYET',
        },
        {
            id: 3,
            name: 'Đang thực hiện',
            value: 'PDNMH_DANGTHUCHIEN',
        },
        {
            id: 4,
            name: 'Không duyệt',
            value: 'PDNMH_KHONGDUYET',
        },
        {
            id: 5,
            name: 'Hoàn tất',
            value: 'PDNMH_HOANTAT',
        },
        {
            id: 6,
            name: 'Đã hủy',
            value: 'PDNMH_DAHUY',
        },
        {
            id: 7,
            name: 'Chờ GĐK duyệt',
            value: 'PDNMH_CHOGDKDUYETGIA',
        },
        {
            id: 8,
            name: 'Chờ GĐ duyệt',
            value: 'PDNMH_CHOGDDUYET',
        },
         {
            id: 8,
            name: 'Chờ checking PR',
            value: 'PDNMH_CHOTPMUAHANGDUYET',
        },
    ];

    Id: number
    SoPhieu: string
    LoaiPhieu: string
    LoaiHangHoaYeuCau: number
    NgayDeNghiCoHang: string
    NgayYeuCau: string
    NguoiYeuCau: number
    TenNguoiYeuCau: string
    PhongBanId: number
    TenPhongBan: string
    DienGiaiLyDo: string
    Nguoitao: number
    TenNguoiTao: string
    Ngaytao: string
    Nguoisua: string
    Ngaysua: string
    IsCreatePo: boolean
    NguoiXacNhan: number
    TenNguoiXacNhan: string
    ThoiGianXacNhan: string
    TpDuyetId: number
    TenTP: string
    TpDuyetLyDo: string
    TpDuyetThoiGian: string
    GdduyetId: number
    TenGD: string
    GdduyetLyDo: string
    GdduyetThoiGian: string
    TpDuyetValue: number
    GdDuyetValue: number
    TinhTrang: string
    TenTinhTrang: string
    TongTien: string
    isVuotHanMuc: boolean
    isVuotHanMucPB: boolean
    isVuotHanMucDuyet: boolean
    IsVisible_Duyet: boolean
    IsEnable_DuyetXacNhan: boolean
    IsVisible_DuyetXacNhan: boolean
    HanMucLapPhieu: string
    listChiTietMuaHang: DeNghiMuaHangCT[]
    listPhieuDeNghiLsThaoTac: PhieuDeNghiLsThaoTac[]

    numChoTPDuyet: number;
    numChoGDKDuyet: number;
    numChoGDDuyet: number;
    numChoDong: number;

    isExpanded: boolean;
    QtdValue: number;

    clear() {
        this.Id = 0;
        this.SoPhieu = '';
        this.LoaiPhieu = '';
        this.LoaiHangHoaYeuCau = 0;
        this.NgayDeNghiCoHang = '';
        this.NgayYeuCau = '';
        this.NguoiYeuCau = 0;
        this.TenNguoiYeuCau = '';
        this.PhongBanId = 0;
        this.TenPhongBan = '';
        this.DienGiaiLyDo = '';
        this.Nguoitao = 0;
        this.TenNguoiTao = '';
        this.Ngaytao = '';
        this.Nguoisua = '';
        this.Ngaysua = '';
        this.IsCreatePo = false;
        this.NguoiXacNhan = 0;
        this.TenNguoiXacNhan = '';
        this.ThoiGianXacNhan = '';
        this.TpDuyetId = 0;
        this.TenTP = '';
        this.TpDuyetLyDo = '';
        this.TpDuyetThoiGian = '';
        this.GdduyetId = 0;
        this.TenGD = '';
        this.GdduyetLyDo = '';
        this.GdduyetThoiGian = '';
        this.TpDuyetValue = 0;
        this.GdDuyetValue = 0;
        this.TinhTrang = '';
        this.TenTinhTrang = '';
        this.TongTien = '';
        this.HanMucLapPhieu = '';
        this.isVuotHanMuc = false;
        this.isVuotHanMucPB = false;
        this.isVuotHanMucDuyet = false;
        this.listChiTietMuaHang = [];
        this.listPhieuDeNghiLsThaoTac = [];
        this.numChoTPDuyet = 0;
        this.numChoGDKDuyet = 0;
        this.numChoGDDuyet = 0;
        this.numChoDong = 0;
        this.isExpanded = false;
        this.IsVisible_Duyet = false;
        this.IsEnable_DuyetXacNhan = false;
        this.IsVisible_DuyetXacNhan = false;
        this.QtdValue = null;
    }
    copy(item: DeNghiMuaHang) {
        this.Id = item.Id;
        this.SoPhieu = item.SoPhieu;
        this.LoaiPhieu = item.LoaiPhieu;
        this.LoaiHangHoaYeuCau = item.LoaiHangHoaYeuCau;
        this.NgayDeNghiCoHang = item.NgayDeNghiCoHang;
        this.NgayYeuCau = item.NgayYeuCau;
        this.NguoiYeuCau = item.NguoiYeuCau;
        this.TenNguoiYeuCau = item.TenNguoiYeuCau;
        this.PhongBanId = item.Id;
        this.TenPhongBan = item.TenPhongBan;
        this.DienGiaiLyDo = item.DienGiaiLyDo;
        this.Nguoitao = item.Nguoitao;
        this.TenNguoiTao = item.TenNguoiTao;
        this.Ngaytao = item.Ngaytao;
        this.Nguoisua = item.Nguoisua;
        this.Ngaysua = item.Ngaysua;
        this.IsCreatePo = item.IsCreatePo;
        this.NguoiXacNhan = item.NguoiXacNhan;
        this.TenNguoiXacNhan = item.TenNguoiXacNhan;
        this.ThoiGianXacNhan = item.ThoiGianXacNhan;
        this.TpDuyetId = item.TpDuyetId;
        this.TenTP = item.TenTP;
        this.TpDuyetLyDo = item.TpDuyetLyDo;
        this.TpDuyetThoiGian = item.TpDuyetThoiGian;
        this.GdduyetId = item.GdduyetId;
        this.TenGD = item.TenGD;
        this.GdduyetLyDo = item.GdduyetLyDo;
        this.GdduyetThoiGian = item.GdduyetThoiGian;
        this.TpDuyetValue = item.TpDuyetValue;
        this.GdDuyetValue = item.GdDuyetValue;
        this.TinhTrang = item.TinhTrang;
        this.TenTinhTrang = item.TenTinhTrang;
        this.TongTien = item.TongTien;
        this.HanMucLapPhieu = item.HanMucLapPhieu;
        this.isVuotHanMuc = item.isVuotHanMuc;
        this.isVuotHanMucPB = item.isVuotHanMucPB;
        this.isVuotHanMucDuyet = item.isVuotHanMucDuyet;
        this.listChiTietMuaHang = item.listChiTietMuaHang;
        this.listPhieuDeNghiLsThaoTac = item.listPhieuDeNghiLsThaoTac;
        this.numChoTPDuyet = item.numChoTPDuyet;
        this.numChoGDKDuyet = item.numChoGDKDuyet;
        this.numChoGDDuyet = item.numChoGDDuyet;
        this.numChoDong = item.numChoDong;
        this.isExpanded = false;
        this.IsVisible_Duyet = item.IsVisible_Duyet;
        this.IsEnable_DuyetXacNhan = item.IsEnable_DuyetXacNhan;
        this.IsVisible_DuyetXacNhan = item.IsVisible_DuyetXacNhan;
        this.QtdValue = item.QtdValue;
    }
}
export class DeNghiMuaHangCT extends BaseModel {

    static category_path = "PDNMH_DETAIL";
    static optionTrangThaiDetail = [
        {
            id: 1,
            name: 'Chờ TP duyệt mua',
            value: 'PDNMH_DETAIL_CHOTPDUYETMUA',
        },
        {
            id: 2,
            name: 'Chờ GĐK duyệt giá',
            value: 'PDNMH_DETAIL_CHOGDKDUYETGIA',
        },
        {
            id: 3,
            name: 'Chờ GĐ duyệt',
            value: 'PDNMH_DETAIL_CHOGDDUYET',
        },
        {
            id: 4,
            name: 'Chờ đóng đề nghị',
            value: 'PDNMH_DETAIL_CHODONGDENGHI',
        },
        {
            id: 5,
            name: 'Hoàn tất',
            value: 'PDNMH_DETAIL_HOANTAT',
        },
        {
            id: 6,
            name: 'Không duyệt',
            value: 'PDNMH_DETAIL_KHONGDUYET'
        },
        {
            id: 7,
            name: 'Chờ TP/NV mua hàng duyệt mua',
            value: 'PDNMH_DETAIL_CHOTPMUAHANGDUYET',
        },
    ]
    static optionsLoaiPhieuDetail: any = [
        {
            id: 1,
            value: 'DENGHIMUAHANGSX',
            name: 'Đề nghị mua hàng theo kế hoạch sản xuất'
        },
    ];

    Id: number;
    PhieuDeNghiId: number;
    HangHoaId: number;
    IdLoaiHH: number;
    MaHang: string;
    TenHang: string;
    QuyCach: string;
    SoLuong: number;
    Dvt: number;
    TenDVT: string;
    GhiChu: string;
    DonGia: string;
    ThanhTien: string;
    NccId: number;
    MaNCC: string;
    TenNCC: string;
    NgayGiaoDuKien: string;
    GhiChuXacNhan: string;
    DaLapDonHang: boolean;
    TienTe_id: number;
    TienTe_Ten: string;
    Tygia: string;
    ThanhTienQuyDoi: string;
    IdPBSD: number
    TenPBSD: string
    IdBPSD: number
    TenBPSD: string
    NgayCanTu: string
    NgayCanDen: string
    XuLy: DM_DuyetChiTietMH
    GiaDuKien: string
    Attachment_id: number
    DaNhanHang: boolean
    FileImport: FileImport
    TrangThaiMatHang: string
    IsEnable_Duyet: boolean
    IsVisible_Duyet: boolean
    IsEnable_DuyetXacNhan: boolean
    IsVisible_DuyetXacNhan: boolean
    //Extends
    SoLuongDaMua: number
    SoLuongDaNhan: number
    TenNguoiDuyet: string
    NgayDuyet: string
    isDuyet: boolean
    LyDoDuyet: string
    isVuotHanMucPB: boolean
    isVuotHanMucDuyet: boolean
    isCreatePo: boolean
    fileTmpDownLoad: any
    isError: boolean
    messageError: string
    NguonPhatSinh_Id: number
    NguonPhatSinh_Type: string
    SoLuongDapUng: number
    GhiChuDapUng: string
    FileTieuChuan: string;
    TrangThaiDapUng: number;
    IdPO: number;
    LoaiPhieuPO: string;
    SoPhieuPO: string;
    listMOQ: any[];
    DvtQuyDoi: number
    SoLuongQuyDoi: number
    listDVTInfo: any[]
    IdKHTuan: number
    QtdValue: number;
    tempId: number; // Temporary ID for copied items (negative values)
    IdHMPB: number;
    SoHMPB: string;
    MaBPSD: string;
    clear() {
        this.Id = 0;
        this.PhieuDeNghiId = 0;
        this.HangHoaId = 0;
        this.IdLoaiHH = 0;
        this.MaHang = '';
        this.TenHang = '';
        this.QuyCach = '';
        this.SoLuong = 0;
        this.Dvt = 0;
        this.TenDVT = '';
        this.GhiChu = '';
        this.DonGia = DeNghiMuaHang.DEFAULT_NUMBER_VALUE_NUMBER;
        this.ThanhTien = '';
        this.NccId = 0;
        this.TenNCC = '';
        this.MaNCC = '';
        this.NgayGiaoDuKien = '';
        this.GhiChuXacNhan = '';
        this.DaLapDonHang = false;
        this.TienTe_id = 0;
        this.TienTe_Ten = '';
        this.Tygia = '1';
        this.ThanhTienQuyDoi = '';
        this.IdPBSD = 0;
        this.TenPBSD = '';
        this.NgayCanTu = '';
        this.NgayCanDen = '';
        this.XuLy = new DM_DuyetChiTietMH();
        this.GiaDuKien = DeNghiMuaHang.DEFAULT_NUMBER_VALUE_NUMBER;
        this.Attachment_id = 0;
        this.DaNhanHang = false;
        this.FileImport = null;
        this.TrangThaiMatHang = '';
        this.IsEnable_Duyet = false;
        this.IsVisible_Duyet = false;
        this.IsEnable_DuyetXacNhan = false;
        this.IsVisible_DuyetXacNhan = false;
        this.SoLuongDaMua = 0;
        this.SoLuongDaNhan = 0;
        this.TenNguoiDuyet = '';
        this.NgayDuyet = '';
        this.isDuyet = true;
        this.LyDoDuyet = '';
        this.isVuotHanMucPB = false;
        this.isVuotHanMucDuyet = false;
        this.isCreatePo = false;
        this.isError = false;
        this.messageError = '';
        this.NguonPhatSinh_Id = 0;
        this.NguonPhatSinh_Type = '';
        this.SoLuongDapUng = 0;
        this.GhiChuDapUng = '';
        this.FileTieuChuan = '';
        this.TrangThaiDapUng = 0;
        this.IdPO = -1;
        this.SoPhieuPO = '';
        this.listMOQ = [];
        this.DvtQuyDoi = 0;
        this.SoLuongQuyDoi = 0;
        this.listDVTInfo = [];
        this.IdKHTuan = null;
        this.QtdValue = null;
        this.IdPBSD = null;
        this.TenPBSD = '';
        this.LoaiPhieuPO = '';
        this.tempId = null;
        this.IdHMPB = null;
        this.SoHMPB = '';
        this.MaBPSD = '';
    }
    copy(item: DeNghiMuaHangCT) {
        this.Id = item.Id;
        this.PhieuDeNghiId = item.PhieuDeNghiId;
        this.HangHoaId = item.HangHoaId;
        this.IdLoaiHH = item.IdLoaiHH;
        this.MaHang = item.MaHang;
        this.TenHang = item.TenHang;
        this.QuyCach = item.QuyCach;
        this.SoLuong = item.SoLuong;
        this.Dvt = item.Dvt;
        this.TenDVT = item.TenDVT;
        this.GhiChu = item.GhiChu;
        this.DonGia = item.DonGia;
        this.ThanhTien = item.ThanhTien;
        this.NccId = item.NccId;
        this.TenNCC = item.TenNCC;
        this.MaNCC = item.MaNCC;
        this.NgayGiaoDuKien = item.NgayGiaoDuKien;
        this.GhiChuXacNhan = item.GhiChuXacNhan;
        this.DaLapDonHang = item.DaLapDonHang;
        this.TienTe_id = item.TienTe_id;
        this.TienTe_Ten = item.TienTe_Ten;
        this.Tygia = item.Tygia;
        this.ThanhTienQuyDoi = item.ThanhTienQuyDoi;
        this.IdPBSD = item.IdPBSD;
        this.TenPBSD = item.TenPBSD;
        this.NgayCanTu = item.NgayCanTu;
        this.NgayCanDen = item.NgayCanDen;
        this.XuLy = item.XuLy;
        this.GiaDuKien = item.GiaDuKien;
        this.Attachment_id = item.Attachment_id;
        this.DaNhanHang = item.DaNhanHang;
        this.TrangThaiMatHang = item.TrangThaiMatHang;
        this.IsEnable_Duyet = item.IsEnable_Duyet;
        this.IsVisible_Duyet = item.IsVisible_Duyet;
        this.IsEnable_DuyetXacNhan = item.IsEnable_DuyetXacNhan;
        this.IsVisible_DuyetXacNhan = item.IsVisible_DuyetXacNhan;
        if (item.FileImport != null) {
            this.FileImport = new FileImport();
            this.FileImport.copy(item.FileImport);
        }
        else {
            this.FileImport = new FileImport();
            this.FileImport.clear();
        }
        this.SoLuongDaMua = item.SoLuongDaMua;
        this.SoLuongDaNhan = item.SoLuongDaNhan;
        this.TenNguoiDuyet = item.TenNguoiDuyet;
        this.NgayDuyet = item.NgayDuyet;
        this.isDuyet = item.isDuyet;
        this.LyDoDuyet = item.LyDoDuyet;
        this.isVuotHanMucPB = item.isVuotHanMucPB;
        this.isVuotHanMucDuyet = item.isVuotHanMucDuyet;
        this.isCreatePo = item.isCreatePo;
        this.isError = item.isError;
        this.messageError = item.messageError;
        this.NguonPhatSinh_Id = item.NguonPhatSinh_Id;
        this.NguonPhatSinh_Type = item.NguonPhatSinh_Type;
        this.SoLuongDapUng = item.SoLuongDapUng;
        this.GhiChuDapUng = item.GhiChuDapUng;
        this.FileTieuChuan = item.FileTieuChuan;
        this.TrangThaiDapUng = item.TrangThaiDapUng;
        this.IdPO = item.IdPO;
        this.SoPhieuPO = item.SoPhieuPO;
        this.listMOQ = item.listMOQ;
        this.DvtQuyDoi = item.DvtQuyDoi;
        this.SoLuongQuyDoi = item.SoLuongQuyDoi;
        this.IdKHTuan = item.IdKHTuan;
        this.QtdValue = item.QtdValue;
        this.IdBPSD = item.IdBPSD;
        this.TenBPSD = item.TenBPSD;
        this.LoaiPhieuPO = item.LoaiPhieuPO;
        this.tempId = item.tempId;
        this.IdHMPB = item.IdHMPB;
        this.SoHMPB = item.SoHMPB;
        this.MaBPSD = item.MaBPSD;
    }

}
export class PhieuDeNghiLsThaoTac extends BaseModel {
    Id: number;
    PhieuDeNghiId: number;
    NguoiThaoTac: number;
    TenNguoiThaoTac: string;
    NgayThaoTac: string;
    LoaiThaoTac: string;
    NoiDung: string;
    GhiChu: string;
    PhieuDeNghiCtId: number;

    clear() {
        this.Id = 0;
        this.PhieuDeNghiId = 0;
        this.NguoiThaoTac = 0;
        this.TenNguoiThaoTac = '';
        this.NgayThaoTac = '';
        this.LoaiThaoTac = '';
        this.NoiDung = '';
        this.GhiChu = '';
        this.PhieuDeNghiCtId = 0;
    }

    copy(item: PhieuDeNghiLsThaoTac) {
        this.Id = item.Id;
        this.PhieuDeNghiId = item.PhieuDeNghiId;
        this.NguoiThaoTac = item.NguoiThaoTac;
        this.TenNguoiThaoTac = item.TenNguoiThaoTac;
        this.NgayThaoTac = item.NgayThaoTac;
        this.LoaiThaoTac = item.LoaiThaoTac;
        this.NoiDung = item.NoiDung;
        this.GhiChu = item.GhiChu;
        this.PhieuDeNghiCtId = item.PhieuDeNghiCtId;
    }
}
export class HHModel extends BaseModel {

    Id_HH: number
    TenHH: string
    MaHH: string
    Id_NhomHH: number
    DVT1: number
    TenDVT: string

    clear() {
        this.Id_HH = 0;
        this.TenHH = '';
        this.MaHH = '';
        this.Id_NhomHH = 0;
        this.DVT1 = 0;
    }
}
export class DM_DuyetChiTietMH extends BaseModel {
    Id: number
    PhieuDeNghi: number
    PhieuDeNghiCT: number
    ListXacNhanNhanHang = []
    NguoiDuyet: number
    TenNguoiDuyet: string
    NgayDuyet: string
    LoaiThaoTac: string
    LyDo: string
    NgayDuyetDate: Date
    TenLoaiThaoTac: string
    CoKetQuaDuyet: boolean
    clear() {
        this.Id = 0
        this.PhieuDeNghi = 0
        this.PhieuDeNghiCT = 0
        this.ListXacNhanNhanHang = []
        this.NguoiDuyet = 0
        this.TenNguoiDuyet = ''
        this.NgayDuyet = ''
        this.LoaiThaoTac = ''
        this.LyDo = ''
        this.NgayDuyetDate = new Date()
        this.TenLoaiThaoTac = ''
        this.CoKetQuaDuyet = false
    }
}
export class FileImport extends BaseModel {
    idLoaiHH: number;
    base64: string;
    fileByte: any;
    filename: string;
    dienGiai: string;
    extension: string;

    clear() {
        this.idLoaiHH = 0;
        this.base64 = '';
        this.fileByte = null;
        this.filename = '';
        this.dienGiai = '';
        this.extension = '';
    }

    copy(item: FileImport) {
        this.idLoaiHH = item.idLoaiHH;
        this.base64 = item.base64;
        this.fileByte = item.fileByte;
        this.filename = item.filename;
        this.dienGiai = item.dienGiai;
        this.extension = item.extension;
    }
}
export class ApproveAllItem extends BaseModel {
    //Loại 1 duyệt chi tiết, loại 2 duyệt danh sách
    Loai: number
    listId: number[]
    LyDo: string
    type: boolean
    QtdValue: number
    clear() {
        this.Loai = null
        this.listId = [];
        this.LyDo = '';
        this.type = false;
        this.QtdValue = null
    }
}

